<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi">
          <span style="color: #f9fcfd; background: #168f77"
            >{{ el.qiShu }}期：</span
          >
          <span style="color: #f9fcfd; background: #3798d9"
            >财神送福10码
            <span style="color: #000">✔</span>
          </span>
        </div>
        <div class="value">
          <div class="code">
            <div>
              [<span
                v-for="(code, codeIndex) in el.yuCe.code16"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >]
            </div>
          </div>
          <div class="code">
            <div>
              [<span
                v-for="(code, codeIndex) in el.yuCe.code10"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >]
            </div>
          </div>
        </div>
        <div v-if="!el.ifZuiXin" class="kaijiang">
          开奖结果：
          <span
            :style="{
              color: el.ifWin ? 'red' : '',
              background: el.ifWin ? '#fffe03' : '',
            }"
            >{{ el.code }} {{ el.shengXiao }}</span
          >
          {{ el.ifWin ? "✅" : "❌" }}
        </div>
        <div style="color: red">❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥ ❥❥ ❥ ❥</div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(to bottom, #b4b9b1, #f1edeb);
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      //   padding: 5px 12px;
      padding: 0;
      font-weight: bold;
      //   display: flex;
      justify-content: center;
      border-bottom: none !important;
      .qi {
        height: 32px;
        span {
          padding: 6px 0;
        }
      }
      .value {
        color: red;
        > div {
          display: flex;
          > span {
            width: 30%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: #222;
          }
          > div {
            padding: 2px 12px;
            display: flex;
            flex-wrap: wrap;
            grid-gap: 5px;
            flex: 1;
            color: #222;
            justify-content: center;
            .win {
              color: red;
              background-color: #fcfb04;
              font-size: 120%;
            }
          }
        }
      }
      .kaijiang {
        padding: 6px 0;
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>